import { render } from "./tw-input.vue?vue&type=template&id=27128bb1"
import script from "./tw-input.vue?vue&type=script&lang=js"
export * from "./tw-input.vue?vue&type=script&lang=js"
script.render = render

export default script